import React from 'react';
import { connect } from 'react-redux';
import FindPeopleIcon from './FindPeopleIcon';
import NavHelp from './NavHelp';
import SearchIcon from './SearchIcon';
import UserInfoDrawerOpener from './UserInfoDrawerOpener';
import LoginButton from './LoginButton';
import FilterBar from './FilterBar';
import ParkingOpeningAlertBar from './ParkingOpeningAlertBar';
import { checkUserLoggedIn, anyFilterSet } from './../../utils';

const NavOptions = ({ isUserLoggedIn, anyFilterSet, eventType, openTime }) => {
  const bookingNotYetOpen = (eventType === 'parking_will_open');
  return (
    <div className="map-nav">
      {anyFilterSet && <FilterBar />}
      { bookingNotYetOpen && <ParkingOpeningAlertBar openTime={openTime} /> }
      <SearchIcon />
      <FindPeopleIcon />
      <NavHelp />
      {isUserLoggedIn ? <UserInfoDrawerOpener /> : <LoginButton /> }
    </div>
  );
};

const mapStateToProps = (state) => {
  const { dtmOpen, dtmClose } = state.mapAccommodationInfo;
  const { eventType, closeTime, openTime } = state.session;

  return {
    isUserLoggedIn: checkUserLoggedIn(state.user),
    anyFilterSet: anyFilterSet(),
    eventType,
    openTime,
  };
};

export default connect(mapStateToProps)(NavOptions);



// WEBPACK FOOTER //
// ./src/containers/NavOptions/index.js